export const EvaluationStatus = {
  REFERRAL: "Referral",
  ASSESSMENTS: "Assessments",
  MEETING: "Meeting",
  COMPLETE: "Complete",
  TERMINATED: "Terminated",
};
